import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import themeConfig from "@configs/themeConfig";
import { useDispatch, useSelector } from "react-redux";
import { getContacts } from "@store/action/smartend/ContactAction";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ContactReducer = useSelector((state) => state.ContactReducer);
  const contact = ContactReducer.data.details;
  useEffect(() => {
    dispatch(getContacts());
  }, []);
  return (
    <div>
      <div className="footer_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <div className="col-lg-3 col-md-6 col-12 col-sm-12">
              <div className="footer_widget footer_about_wrapper ms_cover">
                <div className="wrapper_first_image">
                  <a href="index.html">
                    <img
                      src={themeConfig.app.appLogoImage}
                      className="img-responsive"
                      alt="logo"
                      width="100%"
                    />
                  </a>
                </div>
                <ul className="footer_about_link_wrapper ms_cover">
                  <li>
                    <i className="fa fa-phone" />
                    {contact?.mobile}
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-envelope" />
                      {contact?.email}
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa fa-map-marker" />
                      {contact?.address}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-12 col-sm-12">
              <div className="footer_widget footer_blog_wrapper ms_cover">
                <h4>{t("usefull links")}</h4>
                <ul className="footer_about_link_wrapper usefull_linkx ms_cover">
                  <li>
                    <Link to="/team">{t("Team")}</Link>
                  </li>
                  <li>
                    <Link to="/schedule">{t("Calendar")}</Link>
                  </li>
                  <li>
                    <Link to="/emissions">{t("Emission")}</Link>
                  </li>
                  <li>
                    <Link to="/podcast">{t("Podcasts")}</Link>
                  </li>
                  <li>
                    <Link to="/playlists">{t("Playlists")}</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-6 col-12 col-sm-12">
              <div className="footer_widget footer_contact_wrapper ms_cover">
                <h4>download app </h4>
                <p>All type of app’s available for download</p>
                <span>
                  <a href="#">
                    <img src={app_btn1} className="img-responsive" alt="img" />
                  </a>
                </span>
                <span>
                  <a href="#">
                    <img src={app_btn2} className="img-responsive" alt="img" />
                  </a>
                </span>
                <span>
                  <a href="#">
                    <img src={app_btn3} className="img-responsive" alt="img" />
                  </a>
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="foter_top_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <ul>
            <li>
              <a href="#">
                <i className="fab fa-facebook-f" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-twitter" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-instagram" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-linkedin-in" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-google-plus-g" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-pinterest-p" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-tumblr" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-behance" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-dribbble" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fab fa-whatsapp" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
